
import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { MenuCategory } from "@/data/dashboardData";
import QuickActionsTab from "./tabs/QuickActionsTab";
import RecentActivitiesTab from "./tabs/RecentActivitiesTab";
import UpcomingEventsTab from "./tabs/UpcomingEventsTab";

interface DashboardContentProps {
  menuItems: MenuCategory[];
}

const DashboardContent: React.FC<DashboardContentProps> = ({ menuItems }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <div className="bg-white/[0.08] rounded-xl border border-white/[0.12] overflow-hidden w-full">
      <Tabs defaultValue="quickActions" className="w-full">
        <div className="border-b border-white/10">
          <TabsList className="p-0 bg-transparent h-auto w-full overflow-x-auto flex">
            <TabsTrigger 
              value="quickActions"
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary-foreground text-white/60 py-3 px-4 rounded-none data-[state=active]:shadow-none h-auto flex-shrink-0"
            >
              {isRTL ? "إجراءات سريعة" : "Quick Actions"}
            </TabsTrigger>
            <TabsTrigger 
              value="recentActivities" 
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary-foreground text-white/60 py-3 px-4 rounded-none data-[state=active]:shadow-none h-auto flex-shrink-0"
            >
              {isRTL ? "النشاطات الأخيرة" : "Recent Activities"}
            </TabsTrigger>
            <TabsTrigger 
              value="upcomingEvents" 
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary-foreground text-white/60 py-3 px-4 rounded-none data-[state=active]:shadow-none h-auto flex-shrink-0"
            >
              {isRTL ? "الفعاليات القادمة" : "Upcoming Events"}
            </TabsTrigger>
          </TabsList>
        </div>
        
        <div className="p-4">
          <TabsContent value="quickActions" className="m-0 pt-2">
            <QuickActionsTab menuItems={menuItems} />
          </TabsContent>
          
          <TabsContent value="recentActivities" className="m-0 pt-2">
            <RecentActivitiesTab />
          </TabsContent>
          
          <TabsContent value="upcomingEvents" className="m-0 pt-2">
            <UpcomingEventsTab />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default DashboardContent;
